import { useEffect, useState } from 'react';
import {
  publish,
  subscribe,
  unsubscribe,
} from '@wh/message-bus';
import { StateType as SessionStateType } from '@central-products/interface-session-manager';
import { getDeviceType } from '../../../utils';


export const requestLogin = () => {
  publish('wh.common.event.ui.header.login.requested');
}

export const requestRegistration = () => {
  publish('wh.common.event.ui.header.registration.requested');
}

export const requestDeposit = () => {
  publish('wh.common.event.ui.header.deposit.requested', {
    eventSource: 'Header'
  });
}

export const requestLogo = (data = {}) => {
  publish('wh.common.event.ui.header.logo.requested', data);
}

export const searchClicked = () => {
  publish('wh.common.event.ui.header.search.clicked');
}

export const hamburgerClicked = () => {
  publish('wh.header.event.hamburger.clicked');
}

export const depositLinkClicked = () => {
  publish("wh.myAccount.command.myAccountView.open", { myAccountView: "depositLimitsPage" });
  publish('wh.analytics.command.interaction.track', {
    type: 'link',
    event: {
      tealium_event: 'wh_header_deposit_limit_click',
      NonInteractionEvent: '0',
      EventCategory: 'Menu Interactions',
      EventLabel: 'Deposit Limit Click',
      EventAction: 'Deposit Limit Click',
      ElementType: 'Top Nav',
      DeviceCategory: getDeviceType(),
      SiteSectionSubCategory: null,
      LoginStatus: 'Logged in',
      UserStatus: 'Customer'
    },
  });
}

export const useMessageBusSubscribe = (topic, callback, deps = []) => {
  useEffect(() => {
    const id = subscribe(topic, (topic, ...data) => { callback(...data); });
    return () => {
      unsubscribe(id);
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export const useVisible = ({ topicPrefix, initValue = false }) => {
  const [visible, setVisible] = useState(initValue);

  useMessageBusSubscribe(`${topicPrefix}.show`, () => { setVisible(true); publish(`${topicPrefix}.status`, { visible: true }); });
  useMessageBusSubscribe(`${topicPrefix}.hide`, () => { setVisible(false); publish(`${topicPrefix}.status`, { visible: false }); });

  return visible;
}

export const useLoginVisible = (initValue = false) => useVisible({
  topicPrefix: 'wh.common.command.ui.header.registration.button',
  initValue
});

export const useRegistrationVisible = (initValue = false) => useVisible({
  topicPrefix: 'wh.common.command.ui.header.login.button',
  initValue
});

export const useDepositVisible = (initValue = false) => useVisible({
  topicPrefix: 'wh.common.command.ui.header.deposit.button',
  initValue
});

export const useDepositLinkVisible = (initValue = false) => useVisible({
  topicPrefix: 'wh.common.command.ui.header.deposit.link.button',
  initValue
});

export const sessionStateChanged = 'wh.common.event.session.state.changed';

export const useSessionState = () => {
  useMessageBusSubscribe(sessionStateChanged, ({ state }) => {
    switch (state) {
      case SessionStateType.NOT_LOGGED_IN:
      case SessionStateType.UNKNOWN:
        publish('wh.common.command.ui.header.login.button.show');
        publish('wh.common.command.ui.header.registration.button.show');
        publish('wh.common.command.ui.header.deposit.button.hide');
        publish('wh.common.command.ui.header.deposit.link.button.hide');
        break;
      case SessionStateType.LOGGED_IN:
        publish('wh.common.command.ui.header.login.button.hide');
        publish('wh.common.command.ui.header.registration.button.hide');
        publish('wh.common.command.ui.header.deposit.button.show');
        publish('wh.common.command.ui.header.deposit.link.button.show');
        break;
    }
  });
}

export const useRequestToFlowStart = () => {
  useMessageBusSubscribe('wh.common.event.ui.header.login.requested', () => {
    publish('wh.common.command.ui.login.flow.start');
  });

  useMessageBusSubscribe('wh.common.event.ui.header.registration.requested', () => {
    publish('wh.common.command.ui.registration.flow.start');
  });

  /*useMessageBusSubscribe('wh.common.event.ui.header.deposit.requested', (eventData = {}) => {
    const { closeOnSuccess, eventSource, submitTextKey, pmtSource } = eventData;
    const enableQuickDeposit = window?.kraken?.quickDepositEnabled;
    publish('wh.common.command.ui.header.deposit.open', {
        closeOnSuccess,
        eventSource,
        submitTextKey,
        type: enableQuickDeposit ? 'QUICK_DEPOSIT' : 'DEPOSIT',
        pmtSource,
    });
  });*/
}
